'use client';

import React from 'react';
import { Theme } from '@mui/material';
import Box from '@mui/material/Box';
import { SxProps } from '@mui/system/styleFunctionSx';
import { BlockContainer } from '@/components/Blocks/BlockContainer';
import { BlockTitle } from '@/components/Blocks/components/BlockTitle';
import { prefixCmsUrl } from '@/lib/prefixCmsUrl';
import { CmsFileBlock } from '@/services/cms/blocks/CmsFileBlock';

export interface FileBlockProps extends CmsFileBlock {
    sx?: SxProps<Theme>;
}

export const FileBlock = ({ sx, ...props }: FileBlockProps) => {
    const image = props.file;
    if (!image?.link) {
        return null;
    }
    return (
        <BlockContainer sx={sx} {...props}>
            <BlockTitle {...props} />
            <Box
                component="img"
                src={prefixCmsUrl(image.link)}
                alt={image.title || image.name || ''}
                sx={{
                    height: 'auto',
                    maxWidth: '100%',
                }}
            />
        </BlockContainer>
    );
};
